module.exports = __webpack_public_path__ + "img/pride-2.0caa035b.png";